export default {
    services: state => {
        return state.services;
    },
    serviceCategories: state => {
        return state.serviceCategories;
    },
    serviceToEdit: state => {
        return state.serviceToEdit;
    },
    categories: state => {
        return state.categories;
    },
    properties: state => {
        return state.properties;
    },
    category: state => {
        return state.category;
    },
    title: state => {
        return state.title;
    },
    status: state => {
        return state.status;
    },
    code: state => {
        return state.code;
    },
    property: state => {
        return state.property;
    },
    serviceInsurances: state => {
        return state.serviceInsurances;
    },
    discountGroups: state => {
        return state.discountGroups;
    },
    serviceGroups: state => {
        return state.serviceGroups;
    },
    serviceGenders: state => {
        return state.serviceGenders;
    },
    serviceGender: state => {
        return state.serviceGender;
    },
    femaleSurgeriesService: state => {
        return state.femaleSurgeriesService;
    },
    maleSurgeriesService: state => {
        return state.maleSurgeriesService;
    },
    femaleSonographiesService: state => {
        return state.femaleSonographiesService;
    },
    maleSonographiesService: state => {
        return state.maleSonographiesService;
    },
    total: state => {
        return state.total;
    },
    mriServices: state => {
        return state.mriServices;
    },
    ctScanServices: state => {
        return state.ctScanServices;
    },
    labServices: state => {
        return state.labServices;
    },
}
